import { EnumSchema } from '@40seas/entities/common';
import { WiseTransferRail } from '@40seas/entities/wise';
import { Currency } from '@40seas/models';
import { z } from 'zod';
import { BankAccountAddressSchema } from './bank-account.address.schema';

const accountHolderNameLimitsDictionary = {
    [Currency.USD]: {
        min: 2,
        max: 140,
    },
    [Currency.EUR]: {
        min: 2,
        max: 140,
    },
    [Currency.GBP]: {
        min: 2,
        max: 140,
    },
    [Currency.AUD]: {
        min: 3,
        max: 35,
    },
    [Currency.CAD]: {
        min: 3,
        max: 35,
    },
    [Currency.PLN]: {
        min: 3,
        max: 35,
    },
    [Currency.DKK]: {
        min: 3,
        max: 35,
    },
    [Currency.SEK]: {
        min: 3,
        max: 35,
    },
    [Currency.AED]: {
        min: 3,
        max: 35,
    },
    [Currency.HKD]: {
        min: 3,
        max: 35,
    },
    [Currency.NZD]: {
        min: 3,
        max: 35,
    },
    [Currency.SGD]: {
        min: 3,
        max: 35,
    },
};
export const WiseRecipientRequestSchema = z
    .object({
        currency: EnumSchema(Currency),
        bankDetails: z.any(),
        profile: z.string(),
        address: BankAccountAddressSchema,
        accountHolderName: z.string(),
        moneyRail: EnumSchema(WiseTransferRail),
    })
    .strict()
    .refine(
        (data) =>
            data.accountHolderName?.length >= accountHolderNameLimitsDictionary[data.currency].min &&
            data.accountHolderName?.length <= accountHolderNameLimitsDictionary[data.currency].max,
        (val) => ({
            message: `accountHolderName must have between ${accountHolderNameLimitsDictionary[val?.currency].min} and ${
                accountHolderNameLimitsDictionary[val?.currency].max
            } characters`,
            path: ['accountHolderName'],
        }),
    );
